module.exports = __webpack_public_path__ + "img/google_reviews_video.c463406b.png";